'use client';

import { useLingui } from '@lingui/react';
import { Badge, Flex, Group, Stack, Text, Title, TypographyStylesProvider } from '@mantine/core';
import classes from './BlogDetail.module.css';
import { BlogDetailBanner } from './BlogDetailBanner';
import { BlogSocials } from './BlogSocials';
import { blogs } from './blogs';
export type BlogDetailProps = {
  id: string;
};
export const BlogDetail: React.FC<BlogDetailProps> = ({
  id
}) => {
  const news = blogs.find(item => item.id === id);
  const {
    i18n
  } = useLingui();
  return <Stack align="center">
      <BlogDetailBanner title={`${news?.title}`} />

      <Stack maw={874}>
        <Group justify="space-between" mt={20} mb={40}>
          <Stack gap={0}>
            <Text fz={11} c="var(--text-prime)" tt="uppercase" fw={700}>
              {i18n._('published on')}
            </Text>
            <Text fz="sm" tt="uppercase" c="var(--text-dark)" fw={500}>
              {news?.date}
            </Text>
          </Stack>

          <BlogSocials />
        </Group>

        <TypographyStylesProvider>
          <Title c="var(--text-white)">{'Lorem ipsum dolor sit amet'}</Title>
          <Text fz="sm" c="var(--text-dark)">
            {'Lorem ipsum dolor sit amet consectetur. Nec interdum pulvinar nisi viverra. Vel scelerisque consectetur arcu ultricies. Enim in duis purus posuere nec diam egestas. Ultrices arcu egestas euismod pulvinar posuere massa amet. Amet leo vitae quam eget nunc. Pellentesque diam cum curabitur cras eu et leo rhoncus. Justo elit tellus ut eget eu quisque morbi. Sed est accumsan posuere in tempus arcu. Augue lorem lacus blandit congue varius dolor elementum sollicitudin gravida. Amet tellus dignissim faucibus vel. Odio pellentesque non lacus eu egestas at adipiscing libero ut. Turpis elementum id aenean scelerisque amet. Morbi facilisi sagittis adipiscing facilisis id quisque erat.'}
          </Text>

          <Title c="var(--text-white)" order={3}>
            {'Lorem ipsum dolor sit amet'}
          </Title>

          <Text fz="sm" c="var(--text-dark)">
            {'Lorem ipsum dolor sit amet consectetur. Nec interdum pulvinar nisi viverra. Vel scelerisque consectetur arcu ultricies. Enim in duis purus posuere nec diam egestas. Ultrices arcu egestas euismod pulvinar posuere massa amet. Amet leo vitae quam eget nunc. Pellentesque diam cum curabitur cras eu et leo rhoncus. Justo elit tellus ut eget eu quisque morbi. Sed est accumsan posuere in tempus arcu. Augue lorem lacus blandit congue varius dolor elementum sollicitudin gravida. Amet tellus dignissim faucibus vel. Odio pellentesque non lacus eu egestas at adipiscing libero ut. Turpis elementum id aenean scelerisque amet. Morbi facilisi sagittis adipiscing facilisis id quisque erat.'}
          </Text>

          <Text fz="sm" c="var(--text-dark)">
            {'Lorem ipsum dolor sit amet consectetur. Nec interdum pulvinar nisi viverra. Vel scelerisque consectetur arcu ultricies. Enim in duis purus posuere nec diam egestas. Ultrices arcu egestas euismod pulvinar posuere massa amet. Amet leo vitae quam eget nunc. Augue lorem lacus blandit congue varius dolor elementum sollicitudin gravida. Amet tellus dignissim faucibus vel. Odio pellentesque non lacus eu egestas at adipiscing libero ut. Turpis elementum id aenean scelerisque amet. '}
          </Text>
        </TypographyStylesProvider>

        <Flex direction={{
        base: 'column',
        sm: 'row'
      }} justify="space-between" align={{
        base: 'center',
        sm: 'space-between'
      }} pt={24} mt={40} mb={64} gap={10} className={classes.border}>
          <Group gap={10}>
            {news?.tag.map(item => <Badge size="lg" fz="xs" c="var(--text-dark)" bg="var(--bg-200)" key={item}>
                {item}
              </Badge>)}
          </Group>

          <BlogSocials />
        </Flex>
      </Stack>
    </Stack>;
};